module.exports = __webpack_public_path__ + "static/media/usage.befd949c.svg";